import { gql } from '@apollo/client'

export const EDIT_DASHBOARD_MUTATION = gql`
  mutation editDashboard($workspaceJobInput: EditWorkspaceJobInput!) {
    editWorkspaceJob(workspaceJob: $workspaceJobInput) {
      id
      name
      description
      type
    }
  }
`
